<template>
  <div>
    <!--------------------------->
    <!-- Machines Listing Page -->
    <!--------------------------->
    <h1 v-if="!selectedMachine && !newMachine" style="text-align: center;"><br/><icon name="calendar" scale="5"></icon><br/>SHIFT CATEGORIES</h1>
    <div v-if="!selectedMachine && !newMachine" class="row justify-content-center">
      <button class="btn btn-success" @click="createMachine">Create New Shift Category</button>
    </div>
    <br/>&nbsp;
    <div  v-if="!selectedMachine && !newMachine"class="col-md-12">

      <div class="container">
        <table  class="table table-hover shadows" width="80%;">
          <thead>
          <th scope="col" style="font-size: 12px; background-color: #fffaf0; text-align: center;">ID</th>
          <th scope="col" style="font-size: 12px; background-color: #fffaf0; text-align: center;">Shift Category Name</th>
          <th scope="col" style="font-size: 12px; background-color: #fffaf0; text-align: center; width: 200px;"></th>
          </thead>
          <tbody>
          <tr v-for="machine in machines">
            <td align="center">{{machine.id}}</td>
            <td align="center">{{machine.name}}</td>
            <td align="center">
              <button class="btn btn-primary" @click="selectMachine(machine)"><icon name="refresh"></icon> Update</button>
              <button class="btn btn-danger" @click="deleteMachine(machine.id)"><icon name="times"></icon></button>
            </td>
          </tr>
          </tbody>

        </table>
      </div>



      <br/>
    </div>

    <!--------------------------->
    <!-- Machines Create Page --->
    <!--------------------------->

    <h1  v-if="newMachine && !selectedMachine" style="text-align: center;"><br/><icon name="calendar" scale="5"></icon><br/>CREATE A NEW SHIFT CATEGORY<br/>&nbsp;</h1>
    <div  v-if="newMachine && !selectedMachine"class="col-md-12">
      <div class="container shadows" style="padding: 35px;">

        <div class="row justify-content-center" align="center">
          <div class="col-md-12">
            <h6>Please use the form below to create new record.</h6><hr/>
          </div>
          <div class="col-md-3">
            <h6>Shift Category Name:</h6>
          </div>
          <div class="col-md-9">
            <input :class="{'is-danger-input': machineCreateForm.errors.has('name')}" class="form-control" v-model="machineCreateForm.name" type="text"/>
            <div class="float-left help is-danger" v-if="machineCreateForm.errors.has('name')" v-text="machineCreateForm.errors.get('name')"></div>

          </div>
          <div class="col-md-12">
            <hr/>
            <button class="btn btn-success " type="button" @click="saveMachine" style="margin-right: 5px;"><icon name="save"></icon> Create New Shift Category</button>
            <button v-if="newMachine" class="btn btn-danger" @click="closeMachine" type="button" style="margin-right: 5px;"><icon name="times"></icon> Cancel</button>
          </div>
        </div>

      </div>
    </div>



    <!--------------------------->
    <!-- Machines Details Page -->
    <!--------------------------->

    <h1  v-if="selectedMachine && !newMachine" style="text-align: center;"><br/><icon name="calendar" scale="5"></icon><br/>{{selectedMachine.name}}<br/>&nbsp;</h1>
    <div  v-if="selectedMachine && !newMachine"class="col-md-12">
      <div class="container shadows" style="padding: 35px;">
        <div class="row justify-content-center " align="center">
          <div class="col-md-12">
            <h6>Please use the form below to update {{selectedMachine.name}} details.</h6><hr/>
          </div>
          <div class="col-md-3">
            <h6>Shift Category Name:</h6>
          </div>
          <div class="col-md-9">
            <input :class="{'is-danger-input': machineUpdateForm.errors.has('name')}" class="form-control" v-model="machineUpdateForm.name" type="text"/>
            <div class="float-left help is-danger" v-if="machineUpdateForm.errors.has('name')" v-text="machineUpdateForm.errors.get('name')"></div>
          </div>
          <div class="col-md-12">
            <hr/>
            <button class="btn btn-success" type="button" @click="updateMachine" style="margin-right: 5px;"><icon name="save"></icon> Update Shift Category</button>
            <button v-if="newMachine || selectedMachine" class="btn btn-danger" @click="closeMachine" type="button" style="margin-right: 5px;"><icon name="times"></icon>Cancel</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'AlertsZone',
        data () {
            return {
                machines: null,
                selectedMachine: null,
                newMachine: null,

                machineUpdateForm: new Form({
                    id: null,
                    name: null,
                }),
                machineCreateForm: new Form({
                    name: null,
                }),
            }
        },

        methods: {

            selectMachine(machine){
                this.selectedMachine = machine;
                this.machineUpdateForm.id = machine.id;
                this.machineUpdateForm.name = machine.name;
            },
            closeMachine(){
                this.selectedMachine = null;
                this.machineUpdateForm.id = null;
                this.machineUpdateForm.name = null;
                this.newMachine = null;
                this.loadMachines();
                this.machineUpdateForm.onSuccess('');
                this.machineCreateForm.onSuccess('');
            },
            updateMachine(){
                this.$store.dispatch('shifts/updateShiftCategories', this.machineUpdateForm)
                    .then(response => {
                        this.machineUpdateForm.onSuccess(response);
                        this.loadSingleMachine(this.selectedMachine.id);
                        this.$snotify.success('Shift Category Updated');
                    })
                    .catch(error => {
                        this.machineUpdateForm.onFail(error);
                        this.$snotify.error(this.machineUpdateForm.errors.error.message, this.machineUpdateForm.errors.error.title);
                    })

            },
            deleteMachine(id){
                if(confirm("Do you really want to delete?")) {
                    this.$store.dispatch('shifts/deleteShiftCategories', id)
                        .then(response => {
                            this.loadMachines();
                            this.$snotify.success('Shift Category Deleted Successfully');
                        })
                        .catch(error => {
                            this.machineUpdateForm.onFail(error);
                            this.$snotify.error(this.machineUpdateForm.errors.error.message, this.machineUpdateForm.errors.error.title);
                        })
                }

            },
            createMachine(){
                this.newMachine = true;
                this.selectedMachine = null;
            },
            saveMachine(){

                this.$store.dispatch('shifts/storeShiftCategories', this.machineCreateForm)
                    .then(response => {
                        this.machineCreateForm.onSuccess(response);
                        this.loadMachines();
                        this.newMachine = false;
                        this.$snotify.success('Shift Category Saved');
                    })
                    .catch(error => {
                        this.machineCreateForm.onFail(error);
                        this.$snotify.error(this.machineCreateForm.errors.error.message, this.machineCreateForm.errors.error.title);
                    })
            },

            loadSingleMachine(machineID) {
                // Load Single Company
                this.$store.dispatch('shifts/fetchShiftCategories', machineID)
                    .then(response => {this.selectMachine(response)})
            },

            loadMachines() {
                // Load Companies
                this.$store.dispatch('shifts/fetchShiftCategories')
                    .then(response => {
                        this.machines = this.$store.getters['shifts/getShiftCategories'];
                        // this.$store.dispatch('shifts/fetchLeaveTypes')
                    });
            },

        },

        computed: {
            //
        },

        created() {
            this.loadMachines();
        },

    }
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/settings/hr/shift-categories.vue